export default {
    workOrder_customerDetail_workOrders: "Work Orders",
    workOrder_customerDetail_contacts: "Contacts",
    workOrder_customerDetail_locations: "Locations",
    workOrder_customerDetail_name: "Name",
    workOrder_customerDetail_ein: "EIN",
    workOrder_customerDetail_address: "Address",
    workOrder_customerDetail_tags: "Tags",
    workOrder_customerDetail_customers: "Customers",
    workOrder_customerDetail_edit: "Edit",
    workOrder_customerDetail_delete: "Delete",
    workOrder_customerDetail_email: "Email",
    workOrder_customerDetail_phone: "Phone",
    workOrder_customerDetail_hideDescription: "Hide Description",
    workOrder_customerDetail_showDescription: "Show Description",
}